import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'custom-filter-dias-collapsible',
  templateUrl: './filter-dias-collapsible.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, FaIconComponent],
})
export class FilterDiasCollapsibleComponent implements OnInit {
  readonly title = input<string>(undefined);
  readonly collapsed = input<boolean>(undefined);
  readonly collapsedChange = output<boolean>();

  isCollapsed = false;

  ngOnInit() {
    this.isCollapsed = this.collapsed();
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.collapsedChange.emit(this.isCollapsed);
  }
}
